module.exports = __webpack_public_path__ + "static/media/savings.491b5c50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/savings.svg
// module id = 702
// module chunks = 0